import { useState, useEffect, useRef } from 'react';

// eslint-disable-next-line
const useSlider = <T>(items: T[]) => {
  const [index, setIndex] = useState(0);

  const prevIndex = useRef(index);

  useEffect(() => {
    prevIndex.current = index;
  }, [index]);

  return {
    currentIndex: index,
    currentItem: items[index],
    previousIndex: prevIndex,
    nextIndex: () => (index + 1) % items.length,
    setIndex: (index: number) => setIndex(index),
  };
};

export default useSlider;
